/**
 * Single source of truth for the feedback gate cookie name, shared by every
 * place that has to agree on it:
 *   - api/feedback.mjs        (prod Vercel function — server gate)
 *   - vite.config.mts         (local dev middleware — server gate)
 *   - src/components/feedback/FeedbackWidget.tsx (client <FeedbackGate>)
 *
 * Renaming the cookie is now a one-line change here instead of three files held
 * in sync by comments. Kept at repo root (not under api/, so Vercel's function
 * detection glob doesn't treat it as a function; not under src/, so the server
 * files don't reach into the client tree). Plain `.mjs` with a single const
 * export — safe to bundle into the client and to NFT-trace into the function.
 *
 * The cookie VALUE is the package default ("1") on both the client gate and the
 * server cookieGate(name), so only the name needs sharing.
 */
export const FEEDBACK_COOKIE = 'wh_feedback';
